import React from 'react';
import { Star, ShieldCheck } from 'lucide-react';
import { Review } from './Review';
export function ProductSidebar() {
  return <div className="sticky top-24 bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden" data-id="element-85">
      <div className="p-4 bg-[#1E4D3D] text-white text-center" data-id="element-86">
        <h3 className="font-bold text-lg" data-id="element-87">Glisera Patch</h3>
        <p className="text-sm text-white/80" data-id="element-88">
          Prepare Your Nervous System Safely
        </p>
      </div>

      <div className="p-6" data-id="element-89">
        <div className="mb-4 relative group max-w-[200px] mx-auto" data-id="element-90">
          <img src="https://cdn.magicpatterns.com/uploads/gSSXetTbaofjctckKGEhVg/ChatGPT_Image_10_Ιαν_2026,_12_14_05_μ.μ..png" alt="Glisera Anti-Alcohol Patch box and patches" className="w-full h-auto rounded-lg transform group-hover:scale-105 transition-transform duration-300" data-id="element-91" />
        </div>

        <a href="https://shopglisera.com/products/glisera-anti-alcohol-patch" className="w-full bg-[#1E4D3D] hover:bg-[#163a2e] text-white font-bold py-3 px-4 rounded shadow-md transition-colors mb-4 flex items-center justify-center group" data-id="element-92">
          Check availability
          <span className="ml-2 group-hover:translate-x-1 transition-transform" data-id="element-93">
            {'>>'}
          </span>
        </a>

        <div className="bg-white border border-gray-200 rounded-lg p-4 mb-4 text-center" data-id="element-94">
          <div className="flex justify-center mb-2" data-id="element-95">
            <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center" data-id="element-96">
              <ShieldCheck className="w-8 h-8 text-blue-600" data-id="element-97" />
            </div>
          </div>
          <div className="font-bold text-sm text-gray-900 mb-1" data-id="element-98">
            60-Day Guarantee
          </div>
          <div className="flex justify-center items-center gap-1 mb-1" data-id="element-99">
            <div className="flex text-yellow-400" data-id="element-100">
              {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 fill-current" data-id="element-101" />)}
            </div>
          </div>
          <div className="text-sm font-bold text-gray-900" data-id="element-102">
            4.8 <span className="font-normal text-gray-500" data-id="element-103">/ 5.00</span>
          </div>
          <div className="text-xs text-gray-500" data-id="element-104">Based on 2,847 reviews</div>
        </div>

        <div className="space-y-2 max-h-[300px] overflow-y-auto pr-2 custom-scrollbar" data-id="element-105">
          <Review author="Jennifer K." location="Denver, CO" content="Had a seizure trying cold turkey. This patch let me prepare first. Made it through the 72 hours with no seizure. Life-changing." timeAgo="3 days ago" data-id="element-106" />
          <Review author="Sarah M." location="Portland, OR" content="Hour 36 was when I seized last time. With the patch preparation, I made it through safely. Heart rate stayed under 95." timeAgo="1 week ago" data-id="element-107" />
          <Review author="Michelle R." location="Boston, MA" content="Couldn't afford the $12K medical detox. This worked just as well for $89. No ER visit. No seizure." timeAgo="2 weeks ago" data-id="element-108" />
        </div>

        <button className="w-full mt-4 text-xs text-blue-600 font-medium hover:underline border border-blue-100 rounded py-2 hover:bg-blue-50 transition-colors" data-id="element-109">
          View more reviews
        </button>
      </div>
    </div>;
}